export default <T extends string, TEnumValue extends string>(
  enumVariable: {
    [key in T]: TEnumValue;
  },
  value: unknown
): value is TEnumValue =>
  value != null && Object.values(enumVariable).includes(value);
